import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Me/Home";

const Me = () => {
  return (
    <div className="Me">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Navigate to={"/"} replace />} />
      </Routes>
    </div>
  );
};

export default Me;
